import React, { useState } from 'react';
import { Modal, Button } from '@/components/ui';

interface CompanyLockModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
  companyName: string;
}

export function CompanyLockModal({ isOpen, onClose, onConfirm, isLoading, companyName }: CompanyLockModalProps) {
  const [reason, setReason] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Khóa truy cập công ty"
      variant="danger"
    >
      <div className="p-6">
        <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <i className="ri-lock-2-line text-red-600 text-3xl" />
        </div>

        <h3 className="text-lg font-bold text-slate-900 text-center mb-2">Khóa "{companyName}"</h3>
        <p className="text-sm text-slate-500 text-center mb-6">
          Tất cả người dùng thuộc công ty này sẽ không thể đăng nhập vào hệ thống cho đến khi được mở khóa.
        </p>

        <div className="mb-6">
          <label className="block text-xs font-bold text-slate-500  mb-2">Lý do khóa</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full h-24 p-3 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500/20 focus:border-red-500 transition-all resize-none"
            placeholder="Nhập lý do (ví dụ: Nợ cước phí, Vi phạm điều khoản...)"
          />
        </div>

        <div className="flex gap-3">
          <Button variant="ghost" className="flex-1" onClick={onClose}>Hủy bỏ</Button>
          <Button
            variant="danger"
            className="flex-1"
            isLoading={isLoading}
            disabled={!reason.trim()}
            onClick={() => onConfirm(reason)}
          >
            Xác nhận khóa
          </Button>
        </div>
      </div>
    </Modal>
  );
}
